import { useState, useEffect } from 'react';
import { TextField, Button, Typography, Alert, Stack } from '@mui/material';
import { Surface } from './primitives';
import { normalizeEmail } from '../utils/authUtils';

const ContactForm = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccess(false);
        setError('');
        try {
            const response = await fetch('https://api.capitolgains.io/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...formData,
                    email: normalizeEmail(formData.email),
                }),
            });
            const result = await response.json();
            if (response.ok) {
                setSuccess(true);
                setFormData({ name: '', email: '', message: '' });
            } else {
                throw new Error(result.message || 'Something went wrong');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => setSuccess(false), 8000);
            return () => clearTimeout(timer);
        }
    }, [success]);

    return (
        <>
            <Typography variant="h1" sx={{ color: 'text.primary', mb: 0.5 }}>
                Contact us
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                Questions, feedback, or partnership inquiries — we'd love to hear from you.
            </Typography>

            <Surface component="form" onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    {success && <Alert severity="success">Your message has been sent successfully.</Alert>}
                    {error && <Alert severity="error">{error}</Alert>}
                    <TextField
                        label="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        multiline
                        rows={5}
                        fullWidth
                        required
                    />
                    <Button type="submit" variant="contained" disabled={loading} sx={{ alignSelf: 'flex-start' }}>
                        {loading ? 'Sending…' : 'Send message'}
                    </Button>
                </Stack>
            </Surface>
        </>
    );
};

export default ContactForm;
